/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useMutation, useQuery } from '@apollo/client';
import { getCurrentUserHook, getTranslatedText } from '@nile/components/src';
import {
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  SAVE_PERSONALIZATION
} from '@nile/graphql';
import { noop } from 'lodash';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import { SVGIcon } from '@superops/super-icons';
import {
  AppointmentFloaterPositionHook,
  DEFAULT_POSITION
} from './AppointmentFloaterPositionHook';
import AppointmentForm from './AppointmentForm';

const INTERCOM_Z_INDEX = 999;

const PortalRoot = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 510;
  pointer-events: none;
`;

function AppointmentFloater(props) {
  const {
    position,
    setPosition,
    ref,
    parentRef,
    isDragging
  } = AppointmentFloaterPositionHook({
    deps: [],
    onClick: () => {},
    onMouseUp: () => {}
  });
  return (
    <div
      ref={parentRef}
      className="appointment-floater"
      style={{
        top: position.y,
        left: position.x,
        position: 'absolute',
        touchAction: 'none',
        pointerEvents: 'auto',
        transform: `translate3d(${position.x}px, ${position.y}px)`,
        userSelect: 'none'
      }}
    >
      <div className="floater-drag-area" ref={ref}>
        <div className="flex center  self-center acenter floater-drag-bg">
          <span className="opacity5 pl10 mt5">
            <SVGIcon name="Reorder" />
          </span>
        </div>
      </div>
      <AppointmentForm
        start={props?.start}
        end={props?.end}
        onCancel={props?.onCancel}
        attendees={props?.attendees}
        onSave={props.onSave}
        saveLoading={props?.saveLoading}
        minDate={new Date(props?.schedulingContext?.integratedDate)}
      />
    </div>
  );
}

export default function AppointmentFloaterPortal(props) {
  //   const isMSP = useUserMSPCheckHook();

  //   if (!isMSP) return null;

  return ReactDOM.createPortal(
    <PortalRoot>
      <AppointmentFloater {...props} />
    </PortalRoot>,
    document.body
  );
}
